import _ from 'lodash';

export default function getListFilteredLower(items, f1, f2) {
  return items.filter((i) => _.toLower(i[f1]) === _.toLower(f2));
}
